import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PlatformType } from "@root/config";

@Component({
  selector: "v4-common-account-list",
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.scss"],
})
export class V4CommonAccountListComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;

  @Input() listOfAccount = [];
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 20;
  @Output() onPageChange = new EventEmitter();
  @Output() onDeleteAccount = new EventEmitter();
  @Output() onReconnect = new EventEmitter();
  @Output() onChangePassword = new EventEmitter();
  @Output() onSyncListings = new EventEmitter();
  @Output() onCtripChangeUsername = new EventEmitter();
  @Output() onTongchengAddProperties = new EventEmitter<{ thirdparty_account_id: string; type: "house" | "type" }>();
  trackByID = (index, item) => item.id;
  constructor() {}

  ngOnInit() {}
}
